import styled from 'styled-components'

export const FieldError = styled.p`
  margin: 8px 0 0;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: #cf1322;
`
